<template>

    <div class="card" >

        <div class="card-header"
             v-on:click="isOpen = !isOpen"
        >

            <div class="col-md-9 col-sm-9 col-xs-9 no-padding">
                <div class="title">
                    <span class=" ">{{dateJobStart}}</span>
                    {{quote.job.customer.lastname|Upper}}
                </div>

                <div class="">
                    {{ quote.job.job_description|Truncate(50) }}
                </div>
            </div>

            <div class="col-md-3 col-sm-3 col-xs-3 no-padding tags-info">

                <span class="job-id tag  pull-right half-width">
                    # {{quote.job.id|TruncateJobNumber}}
                </span>

                <span class="pull-right tag tag-danger half-width">
                    <i class="fa fa-edit"></i>
                </span>

            </div>
        </div>


        <transition name="openjob" mode="out-in">
            <div v-bind:class="'card-body'"
                 v-if="isOpen"
                 v-bind:ref="'jobCard'">
                <Quotation
                        v-bind:quote="quote"
                        v-bind:job="quote.job"
                        v-bind:user="user"
                        v-on:quoteDone="quoteDone"
                ></Quotation>

            </div>
        </transition>

    </div>

</template>

<script>

    import PhoneNumberButton from './PhoneNumberButton';
    import CustomerInformation from "./CustomerInformation";
    import Quotation from "./Quotation";
    import moment from 'moment-timezone';

    export default {
        props: {
            quote: null,
            isLoadings: Boolean,
            user:null
        },
        data() {
            return {
                isQuotationEdited: false,
                isOpen: false,
                isQuoteDone:false
            }
        },
        created() {

        },
        methods:{
            quoteDone() {
                this.$emit('get_jobs');
            },
            confirmQuitQuote(){
                const confirmation = confirm("If you go you will lose your edition ");
                if (confirmation === true) {
                    this.isQuotationEdited = false;
                }else{
                    this.isOpen = true;
                }
            }
        },
        filters: {
            Upper(value) {
                if (value !== null) {
                    return value.toUpperCase();
                } else {
                    return value;
                }

            },
            Truncate(value, length) {
                if (value !== null) {
                    return value.substring(0, length) + "..";
                }
                return "";
            },
            TruncateJobNumber(value) {
                return value.toString().substr(2, value.toString().length);
            },
            Round(value) {
                if (value !== null) {
                    return Math.round(value * 100) / 100;
                }
            },
            br(str) {
                return str.replace(/\n/g, "<br />");
            },
            CreateLink(string) {
                var link = "<a href='#conditions_fr'>Condition générales en Francais</a>";
                return string.replace('%onlick_append_conditions_FR%', link);
            }

        },
        watch : {
            quote : {
                handler: function() {
                    this.isQuotationEdited = true;
                },
                deep: true
            },
            isOpen : {
                handler : function(){
                    if(this.isQuotationEdited){
                        this.confirmQuitQuote();
                    }
                }
            }
        },
        components: {
            Quotation,
            CustomerInformation,
            PhoneNumberButton,
        },
        computed : {
            dateJobStart(){
                    return moment(this.quote.job.date_job_start).format('HH:mm');
            }
        }
    }
</script>

<style scoped>
    .policyContent {
        background-color: #f7fffa;
        z-index: 222223;
        padding: 18px 8px;
        color: black;
        position: fixed;
        left: 0px;
        top: 0px;
        height: 100%;
        width: 100%;
    }

    .tags-info .tag {
        font-size: 12px;
        border-radius: 0px;
    }

    .price-policy-btn {
        background-color: #ff4b18 !important;
    }

    .little-padding {
        padding: 4px !important;
    }

    .call-btns .btn-call {
        border-radius: 4px;
        border: 1px solid #dddddd !important;
        background-color: white !important;
    }

    .call-btns .btn-call:last-child {
        margin-left: 10px;
    }

    .address {
        text-transform: lowercase;

    }

    .job-id {
        padding: 4px !important;
        text-align: right;
    }

    .padding-startquizz-buttons {
        padding-right: 10px !important;;
        padding-left: 10px !important;
    }

    #job-worker-list .quizz.startQuizz {
        margin-bottom: 10px !important;
        padding: 20px;
    }

    .items-background {
        background: #f5f5f5;
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 25px;
    }

    .btn-group-spaced {
        padding: 3px !important;
        margin: 0px !important;
    }

    .scrollable {
        height: 450px;
        overflow: hidden;
        overflow-y: scroll
    }

    .job_completed {
        background-color: #cbcbcb !important;
    }

    .job_completed_card {
        border-color: #cbcbcb !important;
    }

    .txt-red {
        color: red;
    }

    .job-number {
        background-color: #3f85d6;
        position: absolute;
        right: 0px;
        top: 0px;
        margin: 10px;
        padding: 4px;
        color: white;
    }

    .btn-confirm {
        color: white;
        background-color: red;
    }

    .btn-confirm:hover {
        color: white !important;
        background-color: #d90000;
    }

</style>

